/**
 * Throw a hard 404 when CMS page data is missing (avoids soft-404 HTTP 200).
 * Also treats Kirby CMS "error" template pages as not found.
 */
export function requirePageData<T>(
  data: T | null | undefined,
  statusMessage = "Page not found",
): T {
  if (
    data == null ||
    (typeof data === "object" &&
      data !== null &&
      "template" in data &&
      (data as { template?: string }).template === "error")
  ) {
    throw createError({
      statusCode: 404,
      statusMessage,
      fatal: true,
    });
  }
  return data;
}
